import React, { useState, useEffect, useRef } from "react";
import { Input, Popup } from "semantic-ui-react";
import { CM_LOGO, SELECTED_HOTEL_NAME, USER_DATA } from "../../../../constants";

const SelectBoxHeader = (props) => {
  // Read fresh on every render — the auth call refreshes user_data after this
  // component mounts, and props.items must not be frozen into state at mount.
  const hotelsArr = JSON.parse(localStorage.getItem(USER_DATA));
  const items = props.items || [];
  const [showItems, setShowItems] = useState(false);
  const [selectedItem, setSelectedItem] = useState(
    props.defaultValue || "Select Your Hotel"
  );
  const [inputValue, setInputValue] = useState("");
  const dropdownRef = useRef(null);

  const selectItem = (item) => {
    props.handleChange("e", item);
    props.dispatch({ type: "clear_holida_bookings_res" });
    setSelectedItem(item);
    setShowItems(false);
  };

  const dropDown = (e) => {
    if (e.target.closest("input")) return;
    setShowItems((prev) => !prev);
    setInputValue("");
  };
  
  const closeDropdown = (e) => {
    e.stopPropagation();
    setShowItems(false);
  };

  return (
    <div
      ref={dropdownRef}
      className={`select-box--box-header ${showItems ? "dark_bg_header" : ""}`}
    >
      <div
        className={`select-box--container-header ${
          props.location.pathname.includes("/holida-inventory") ? "holida" : ""
        }`}
      >
        <div
          onClick={(e) => dropDown(e)}
          className={`select-box--selected-item-header ${
            showItems ? "select-box-search" : ""
          }`}
          style={{
            color: props.location.pathname.includes("/holida-inventory")
              ? "black"
              : "",
          }}
        >
          <span className="header-dropdown-selected-hotel">
            {!showItems &&
              (selectedItem.text
                ? selectedItem.text
                : localStorage.getItem(SELECTED_HOTEL_NAME))}
          </span>
          {showItems && (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                style={{
                  marginLeft: "2rem",
                  width: "1.5rem",
                  height: "1.5rem",
                }}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.5348 8.10075C14.5348 11.6542 11.6542 14.5348 8.10075 14.5348C4.5473 14.5348 1.66667 11.6542 1.66667 8.10075C1.66667 4.5473 4.5473 1.66667 8.10075 1.66667C11.6542 1.66667 14.5348 4.5473 14.5348 8.10075ZM13.209 14.3882C11.8153 15.5219 10.0374 16.2015 8.10075 16.2015C3.62683 16.2015 0 12.5747 0 8.10075C0 3.62683 3.62683 0 8.10075 0C12.5747 0 16.2015 3.62683 16.2015 8.10075C16.2015 10.0377 15.5217 11.8159 14.3876 13.2097L19.8181 18.6401C20.1435 18.9656 20.1435 19.4932 19.8181 19.8187C19.4926 20.1441 18.965 20.1441 18.6396 19.8187L13.209 14.3882Z"
                  fill="#9B97A0"
                />
              </svg>
              <Input
                inverted
                onChange={(e) => setInputValue(e.target.value)}
                value={inputValue}
                placeholder={"Search Your Hotel"}
                style={{
                  width: "90%",
                  border: "hidden",
                  height: "45px",
                }}
              />
            </>
          )}
          <div>
            {showItems ? (
              <svg
                onClick={(e) => closeDropdown(e)}
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                style={{ width: "1rem", height: "1rem", marginRight: "1.5rem" }}
              >
                <path
                  d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
                  fill="#818181"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="6"
                viewBox="0 0 12 6"
                fill="none"
                style={{ marginRight: "1.5rem" }}
              >
                <path
                  d="M0 -3.05176e-05L6 5.99997L12 -3.05176e-05H0Z"
                  fill="#303030"
                />
              </svg>
            )}
          </div>
        </div>

        <div style={{ paddingInline: "0.35rem" }}>
          <div
            style={{
              display: showItems ? "block" : "none",
              height: "auto",
              maxHeight: "210px",
              borderTop: "1px solid #DDD",
              overflow: "auto",
              borderRadius: "0 0 1.5rem 1.5rem",
            }}
            className="select-box--items-header topscrollbar_mobile_new"
          >
            {items
              .filter((option) =>
                option.text.toLowerCase().includes(inputValue.toLowerCase())
              )
              .map((option) => (
                <div
                  key={option.text}
                  onClick={() => selectItem(option)}
                  className="header-dropdown-hotel-options"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>{option.text}</span>
                  {hotelsArr?.hotels.some(
                    (hotel) => hotel.hotel_name === option.text
                  ) &&
                    hotelsArr.hotels
                      .filter((hotel) => hotel.hotel_name === option.text)
                      .map(
                        (hotel) =>
                          hotel.active_channel_manager === "1" && (
                            <Popup
                              trigger={
                                <div
                                  style={{
                                    border: "none",
                                    marginRight: "-1.5rem",
                                  }}
                                >
                                  <img
                                    src={CM_LOGO[hotel.active_channel_manager_name]}
                                    style={{
                                      width: "1.5rem",
                                      height: "1.5rem",
                                      marginLeft: "auto",
                                    }}
                                    alt={`${hotel.active_channel_manager_name} Logo`}
                                  />
                                </div>
                              }
                            />
                          )
                      )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectBoxHeader;
